import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { InventoryTransferDetailModel } from 'src/app/models/inventory/inventory-transfer-detail.model';
import { InventoryTransferModel } from 'src/app/models/inventory/inventory-transfer.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryTransferDetailCaptureTableModel } from 'src/app/models/tables/inventory/inventory-transfer-detail-capture-table.model';
import { InventoryTransferDetailService } from 'src/app/services/inventory/inventory-transfer-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inventory-transfer-detail',
  templateUrl: './inventory-transfer-detail.component.html',
  styleUrls: ['./inventory-transfer-detail.component.scss'],
  standalone: false
})
export class InventoryTransferDetailComponent implements OnInit {

  @Input() inventoryTransferModel: InventoryTransferModel = new InventoryTransferModel();
  @Input() disabledDetail: boolean = false;
  @Input() updateListDetail: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  detailData: PagedResponseModel<InventoryTransferDetailCaptureTableModel> = new PagedResponseModel<InventoryTransferDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  inventoryTransferDetailModel: InventoryTransferDetailModel = new InventoryTransferDetailModel();
  isFormView: boolean = false;
  isFormViewOpen: boolean = false;
  limit: number = 10;
  page: number = 1;
  tableActions: TableAction[] = [{
    label: 'Editar',
    icon: 'pi pi-pencil',
    action: 'edit'
  }];

  constructor(private inventoryTransferDetailService: InventoryTransferDetailService,
    private toastHandlerService: ToastHandlerService,) { }

  async ngOnInit(): Promise<void> {
    await this.getColumns();
  }

  ngOnChanges(changes: SimpleChanges) {
    const updateListDetail = changes["updateListDetail"];
    if (updateListDetail && !updateListDetail.firstChange) {
      this.getDetailsForCaptureTable();
    }
    const inventoryTransferModel = changes["inventoryTransferModel"];
    if (inventoryTransferModel && !inventoryTransferModel.firstChange) {
      this.clearSelectionTrigger++;
      this.getFormView(false);
      this.getDetailsForCaptureTable();
      this.inventoryTransferDetailModel = new InventoryTransferDetailModel();
    }
    const disabledDetail = changes["disabledDetail"];
    if (disabledDetail && !disabledDetail.firstChange) {
      this.tableActions = this.disabledDetail ? [] : [{
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }];
    }
  }

  async createNewDetail() {
    this.isFormViewOpen = !this.isFormViewOpen;
    this.inventoryTransferDetailModel = new InventoryTransferDetailModel();
  }

  async deleteSomeDetails(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle seleccionado del traslado?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.inventoryTransferDetailService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast('success', 'El detalle fue eliminado exitosamente.');
        this.clearSelectionTrigger++;
        this.getUpdateListDetailByDelete();
      } catch (error) {
        this.getUpdateListDetailByDelete();
        console.error('Error al eliminar los detalles del traslado.', error);
      }
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.inventoryTransferDetailService.getColumnsForCaptureTable());
    } catch (error) {
      console.error('Error searching columns for query.', error);
    }
  }

  async getDetailsForCaptureTable() {
    try {
      this.detailData = await firstValueFrom(this.inventoryTransferDetailService.getDetailsForCaptureTable(this.page, this.limit, this.columnSort,
        this.ascendant, this.inventoryTransferModel.inventoryTransferId));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error searching details services.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getInventoryTransferDetailById(id: number) {
    try {
      this.inventoryTransferDetailModel = await firstValueFrom(this.inventoryTransferDetailService.getInventoryTransferDetailById(id));
    } catch (error) {
      console.error('Error fetching devolution detail by ID.', error);
    }
  }

  getUpdateListDetailByDelete() {
    this.inventoryTransferDetailModel = new InventoryTransferDetailModel();
    this.getDetailsForCaptureTable();
  }

  async onAction(event: { action: string, item?: InventoryTransferDetailCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      this.getFormView(true);
      await this.getInventoryTransferDetailById(event.item!.id);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteSomeDetails(event.selectedItems);
      console.warn('Bulk delete action.', event.selectedItems);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getDetailsForCaptureTable();
  }
}
